/* Page Avis : filtre par note (histogramme), tri, et « Afficher plus d'avis »
   par lots de 50.

   Deux modes :
   - distant (normal) : le Worker supermot-avis (archive maison de TOUS les
     avis Judge.me, cloudflare/avis) fournit les avis page par page, filtrés
     et triés, plus l'histogramme et le total. Les 50 tuiles rendues par
     Liquid sont réutilisées quand l'avis est le même ; les autres sont
     construites ici, à l'identique du snippet avis-tuile.
   - local (Worker injoignable) : comme avant, sur les avis du métafield
     rendus par Liquid (80 au plus).
   avis-grille.js range les tuiles en quinconce (window.SupermotAvisGrille).
   Sans JS, toutes les tuiles Liquid restent visibles. */
(function () {
  'use strict';

  var dataEl = document.getElementById('av-data');
  var api = window.SupermotAvisGrille;
  if (!dataEl || !api) return;
  var D = JSON.parse(dataEl.textContent);
  /* le filtre t de Shopify encode les apostrophes (&#39;) : on décode, ces
     textes sont posés en textContent */
  var decodeur = document.createElement('textarea');
  var T = {};
  Object.keys(D.t || {}).forEach(function (k) {
    decodeur.innerHTML = D.t[k];
    T[k] = decodeur.value;
  });
  var PAR = D.par || 50;
  var MANUELLES = D.reponses || {};

  var vide = document.getElementById('av-vide');
  var fin = document.getElementById('av-fin');
  var plus = document.getElementById('av-plus');
  var boutonPlus = plus.querySelector('button');
  var compteur = document.getElementById('av-compteur');
  var reset = document.getElementById('av-reset');
  var triSel = document.getElementById('av-tri');
  var barres = Array.prototype.slice.call(document.querySelectorAll('.av-bar'));
  var texteVide = vide.textContent;

  /* tuiles Liquid, par identifiant d'avis */
  var LOCAUX = api.tuiles.map(function (el) {
    return { el: el, id: el.getAttribute('data-uuid'), note: parseInt(el.getAttribute('data-note'), 10), iso: el.getAttribute('data-iso') };
  });
  var parId = {};
  LOCAUX.forEach(function (a) { if (a.id) parId[a.id] = a.el; });

  var etat = { mode: 'local', filtre: null, tri: 'recents', page: 0, pages: 1, total: 0, totalTous: 0, reste: 0, enCours: null };

  /* ---------- construction d'une tuile depuis le Worker ---------- */

  var DATE_FR = new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Paris' });

  function el(tag, classe, texte) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    if (texte !== undefined) e.textContent = texte;
    return e;
  }

  function texteMultiligne(p, texte) {
    String(texte || '').split('\n').forEach(function (ligne, i) {
      if (i) p.appendChild(document.createElement('br'));
      p.appendChild(document.createTextNode(ligne));
    });
    return p;
  }

  function etoiles(note) {
    var s = el('span', 'etoiles');
    s.setAttribute('aria-hidden', 'true');
    s.appendChild(el('span', 'etoiles-fond', '★★★★★'));
    var plein = el('span', 'etoiles-plein', '★★★★★');
    plein.style.width = Math.max(0, Math.min(100, note * 20)) + '%';
    s.appendChild(plein);
    return s;
  }

  /* image Judge.me d'abord, notre copie si elle ne charge pas */
  function image(src, secours, attrs) {
    var img = document.createElement('img');
    Object.keys(attrs || {}).forEach(function (k) { img.setAttribute(k, attrs[k]); });
    img.loading = 'lazy';
    img.decoding = 'async';
    if (secours) {
      img.addEventListener('error', function repli() {
        img.removeEventListener('error', repli);
        img.removeAttribute('srcset');
        img.src = secours;
      });
    }
    img.src = src;
    return img;
  }

  function construire(a) {
    var art = el('article', 'avt');
    art.setAttribute('data-note', a.note);
    art.setAttribute('data-iso', a.date);
    art.setAttribute('data-uuid', a.id);
    var photo = a.photos && a.photos[0];

    if (a.video) {
      var b = el('button', 'avt-photo avt-video');
      b.type = 'button';
      b.setAttribute('data-avis-video', '');
      b.setAttribute('data-src-480', a.video.src[480]);
      b.setAttribute('data-src-720', a.video.src[720]);
      b.setAttribute('data-secours-480', a.video.secours[480]);
      b.setAttribute('data-secours-720', a.video.secours[720]);
      b.setAttribute('data-poster', a.video.src.poster);
      b.setAttribute('aria-label', T.lire_video.replace('{n}', a.auteur));
      b.appendChild(image(photo ? photo.src[480] : a.video.src.poster, photo ? photo.secours[480] : a.video.secours.poster, { alt: '', width: '480', height: '480' }));
      b.appendChild(el('span', 'avis-play')).setAttribute('aria-hidden', 'true');
      if (a.photos.length) b.appendChild(el('span', 'avt-nb', '+' + a.photos.length)).setAttribute('aria-hidden', 'true');
      art.appendChild(b);
    } else if (photo) {
      var z = el('button', 'avt-photo');
      z.type = 'button';
      z.setAttribute('data-avis-zoom', photo.src[1024]);
      z.setAttribute('data-avis-zoom-secours', photo.secours[1024]);
      z.setAttribute('aria-label', T.agrandir);
      z.appendChild(image(photo.src[480], photo.secours[480], {
        srcset: photo.src[480] + ' 480w, ' + photo.src[720] + ' 720w',
        sizes: '(min-width: 1000px) 300px, (min-width: 700px) 33vw, 50vw',
        alt: T.photo_alt.replace('{n}', a.auteur), width: '480', height: '480'
      }));
      if (a.photos.length > 1) z.appendChild(el('span', 'avt-nb', '+' + (a.photos.length - 1))).setAttribute('aria-hidden', 'true');
      art.appendChild(z);
    }

    var corps = el('div', 'avt-corps');
    var qui = el('div', 'avt-qui');
    qui.appendChild(el('b', '', a.auteur));
    var t = el('time', '', DATE_FR.format(new Date(a.date)));
    t.setAttribute('datetime', a.date.slice(0, 10));
    qui.appendChild(t);
    corps.appendChild(qui);

    var note = el('div', 'avt-note');
    var et = el('span');
    et.setAttribute('role', 'img');
    et.setAttribute('aria-label', T.note_sr.replace('{n}', a.note));
    et.appendChild(etoiles(a.note));
    note.appendChild(et);
    if (a.verifie) note.appendChild(el('span', 'avt-ok', '✓ ' + T.verifie));
    else if (a.ancien_site) note.appendChild(el('span', 'avt-ok', T.ancien_site));
    corps.appendChild(note);

    corps.appendChild(texteMultiligne(el('p'), a.texte));

    var rep = a.reponse || MANUELLES[a.id];
    if (rep) {
      var r = el('div', 'avt-rep');
      r.appendChild(el('div', 'avt-rep-t', T.reponse));
      r.appendChild(texteMultiligne(el('p'), rep));
      corps.appendChild(r);
    }

    if (a.produit && a.produit.titre) {
      var pr = el(a.produit.url ? 'a' : 'div', 'avt-produit');
      if (a.produit.url) pr.href = a.produit.url;
      if (a.produit.image) pr.appendChild(image(a.produit.image, null, { alt: '', width: '44', height: '44' }));
      pr.appendChild(el('span', '', a.produit.titre));
      corps.appendChild(pr);
    }
    art.appendChild(corps);
    api.preparer(art);
    return art;
  }

  function tuile(a) {
    if (!parId[a.id]) parId[a.id] = construire(a);
    return parId[a.id];
  }

  /* ---------- interface ---------- */

  var grille = api.creer(api.grille, {
    apresMaj: function (e) {
      etat.reste = e.reste;
      var encore = etat.mode === 'distant' ? (e.reste > 0 || etat.page < etat.pages) : e.reste > 0;
      vide.hidden = e.total > 0;
      fin.hidden = !(!encore && e.total > 0);
      plus.hidden = !encore;
      majCompteur(etat.mode === 'distant' ? etat.total : e.total);
    }
  });

  function majCompteur(n) {
    var distant = etat.mode === 'distant';
    if (etat.filtre) {
      compteur.textContent = (distant ? T.compteur_filtre_tous : T.compteur_filtre).replace('{n}', n).replace('{note}', etat.filtre);
      reset.classList.add('on');
    } else {
      compteur.textContent = (distant ? T.compteur_tous : T.compteur).replace('{n}', distant ? etat.totalTous : n);
      reset.classList.remove('on');
    }
  }

  function majHistogramme(histo) {
    var maxi = 1;
    Object.keys(histo).forEach(function (k) { maxi = Math.max(maxi, histo[k]); });
    barres.forEach(function (b) {
      var n = histo[b.getAttribute('data-note')] || 0;
      var nb = b.querySelector('.nb');
      var i = b.querySelector('.track i');
      if (nb) nb.textContent = n;
      if (i) i.style.width = Math.round(n * 930 / maxi) / 10 + '%';
    });
  }

  function chargement(oui) {
    boutonPlus.disabled = oui;
    boutonPlus.textContent = oui ? T.chargement : T.afficher_plus;
  }

  /* ---------- Worker ---------- */

  function demander(page) {
    var q = '?page=' + page + '&par=' + PAR + '&tri=' + encodeURIComponent(etat.tri) + (etat.filtre ? '&note=' + etat.filtre : '');
    var ctrl = window.AbortController ? new AbortController() : null;
    var minuteur = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    return fetch(D.api + q, ctrl ? { signal: ctrl.signal } : {}).then(
      function (r) {
        clearTimeout(minuteur);
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      },
      function (e) {
        clearTimeout(minuteur);
        throw e;
      }
    );
  }

  /* première page de la sélection courante (filtre, tri) */
  function chargerDebut(avecAnimation) {
    var jeton = {};
    etat.enCours = jeton;
    return demander(1).then(function (d) {
      if (etat.enCours !== jeton) return;
      etat.mode = 'distant';
      etat.page = 1;
      etat.pages = d.pages;
      etat.total = d.total;
      etat.totalTous = d.total_tous;
      majHistogramme(d.histo);
      vide.textContent = T.vide_tous;
      grille.definir(d.avis.map(tuile), avecAnimation);
    });
  }

  function chargerSuite() {
    chargement(true);
    var jeton = {};
    etat.enCours = jeton;
    demander(etat.page + 1).then(function (d) {
      if (etat.enCours !== jeton) return;
      etat.page += 1;
      etat.pages = d.pages;
      etat.total = d.total;
      chargement(false);
      grille.etendre(d.avis.map(tuile));
      grille.ajouter();
    }).catch(function () {
      chargement(false); /* le bouton reste là pour réessayer */
    });
  }

  /* ---------- mode local (repli) ---------- */

  function selectionLocale() {
    var liste = LOCAUX.slice();
    if (etat.filtre) liste = liste.filter(function (a) { return a.note === etat.filtre; });
    if (etat.tri === 'recents') liste.sort(function (a, b) { return a.iso < b.iso ? 1 : -1; });
    if (etat.tri === 'haut') liste.sort(function (a, b) { return b.note - a.note || (a.iso < b.iso ? 1 : -1); });
    if (etat.tri === 'bas') liste.sort(function (a, b) { return a.note - b.note || (a.iso < b.iso ? 1 : -1); });
    return liste.map(function (a) { return a.el; });
  }

  /* nouveau filtre ou tri : on (re)demande au Worker ; la demande précédente
     encore en route est ignorée (jeton) ; Worker injoignable : tri local */
  function reRendre() {
    chargerDebut(true).catch(function () {
      etat.mode = 'local';
      etat.enCours = null;
      vide.textContent = texteVide;
      grille.definir(selectionLocale(), true);
    });
  }

  /* ---------- événements ---------- */

  /* tuiles déjà reçues mais pas encore montrées : on les montre ; sinon,
     en mode distant, on demande le lot suivant au Worker */
  boutonPlus.addEventListener('click', function () {
    if (etat.reste > 0) grille.ajouter();
    else if (etat.mode === 'distant' && etat.page < etat.pages) chargerSuite();
  });

  barres.forEach(function (b) {
    b.addEventListener('click', function () {
      var n = parseInt(b.getAttribute('data-note'), 10);
      etat.filtre = (etat.filtre === n) ? null : n;
      barres.forEach(function (x) {
        x.setAttribute('aria-pressed', String(parseInt(x.getAttribute('data-note'), 10) === etat.filtre));
      });
      reRendre();
      document.querySelector('.av-sec').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  reset.addEventListener('click', function () {
    etat.filtre = null;
    barres.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    reRendre();
  });

  triSel.addEventListener('change', function () {
    etat.tri = triSel.value;
    reRendre();
  });

  /* départ : tout de suite en local (les tuiles Liquid), puis bascule sur
     le Worker dès qu'il répond */
  grille.definir(selectionLocale(), false);
  chargerDebut(false).catch(function () { /* Worker injoignable : on reste en local */ });
})();
